module.exports = __webpack_public_path__ + "img/course_bg04.1a190cc2.png";